import { MobileSidebar } from './Sidebar';
import { useAuth } from '@/lib/auth-context';
import { Badge } from '@/components/ui/badge';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { NotificationBell } from '@/components/NotificationBell';

export function Topbar() {
  const { user } = useAuth();

  const getRoleBadge = () => {
    if (!user) return null;
    const roleMap = {
      super_user: { label: 'Super Admin', variant: 'default' },
      manager: { label: 'Manager', variant: 'secondary' },
      staff: { label: user?.staff_role || 'Staff', variant: 'outline' },
    };
    const r = roleMap[user.role] || { label: user.role, variant: 'outline' };
    return <Badge variant={r.variant} className="capitalize text-xs">{r.label}</Badge>;
  };

  const initials = user?.name?.split(' ').map(n => n[0]).join('').substring(0, 2).toUpperCase() || '?';

  return (
    <header className="sticky top-0 z-30 flex items-center justify-between h-14 px-4 md:px-6 border-b bg-card/95 backdrop-blur supports-[backdrop-filter]:bg-card/75">
      <div className="flex items-center gap-3">
        <MobileSidebar />
        <div className="lg:hidden flex items-center gap-2">
          <img src="/visaxpress-logo.svg" alt="VisaXpress" className="h-7 object-contain" />
          <Badge variant="outline" className="text-[9px] px-1 py-0 font-heading tracking-wider">FALCON</Badge>
        </div>
      </div>
      <div className="flex items-center gap-3">
        <NotificationBell />
        {getRoleBadge()}
        <div className="hidden sm:block text-right">
          <p className="text-sm font-medium">{user?.name}</p>
          <p className="text-xs text-muted-foreground">{user?.email}</p>
        </div>
        <Avatar className="h-8 w-8">
          {user?.picture && <AvatarImage src={user.picture} alt={user.name} />}
          <AvatarFallback className="bg-primary/10 text-primary text-xs font-medium">{initials}</AvatarFallback>
        </Avatar>
      </div>
    </header>
  );
}
